import { AbstractControl, ValidatorFn } from '@angular/forms';

export function emptyString(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const err = { required: true };
    const value = control.value ? control.value.trim() : null;
    return !value ? err : null;
  };
}
